import React from "react";
import { Pie } from "react-chartjs-2";

const AtendimentoOportunidades = ({
  leadsAtendidos,
  apolicesEmitidas,
  apolicesPendentes,
  dataAtualizacao
}) => {
  const data = {
    labels: ['Leads atendidos', 'Apólices emitidas', 'Apólices pendentes'],
    datasets: [
      {
        data: [leadsAtendidos, apolicesEmitidas, apolicesPendentes],
        backgroundColor: ['#f26324', '#53a653', '#d93b3b'],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true, // ✅ Habilita legenda de séries
        position: 'bottom',
        labels: {
          font: {
            size: 14,
          },
          usePointStyle: true,
          padding: 16,
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.label}: ${tooltipItem.raw}`;
          },
        },
      },
    },
  };




  return (
    <div className="container my-4">
      <div className="row">
        <div className="col-md-6">
          <h3 className="card-title text-dark font-weight-bold mb-4">Atendimento / Oportunidades</h3>

          <div className="form-group">
            <label>Leads atendidos:</label>
            <input
              type="text"
              className="form-control"
              value={`${leadsAtendidos} leads`}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>Apólices emitidas:</label>
            <input
              type="text"
              className="form-control"
              value={`${apolicesEmitidas} apólices`}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>Apólices pendentes:</label>
            <input
              type="text"
              className="form-control"
              value={`${apolicesPendentes} apólices`}
              readOnly
            />
          </div>

          <div className="d-flex align-items-center mt-3 text-muted">
            <i className="fas fa-clock mr-2 text-warning"></i>
            <small>Atualizado em: {dataAtualizacao}</small>
          </div>
        </div>

        {/* Gráfico e legenda */}
        <div className="col-md-6 d-flex flex-column align-items-center justify-content-center">
          <Pie data={data} options={options} />
        </div>
      </div>
    </div>
  );
};

export default AtendimentoOportunidades;
